// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PortalCaregivers-module__article___o_4Db {
  padding: 27px 24px;
}

.PortalCaregivers-module__heading____HUeu {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 16px;
  color: #375844;
}

.PortalCaregivers-module__inviteList___LjPpu {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.PortalCaregivers-module__inviteRow___ICYMp {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 12px 0;
  border-bottom: 1px solid #f1f3e7;
  gap: 7rem;
}

.PortalCaregivers-module__info___jBY1z {
  display: flex;
  flex-direction: column;
  min-width: 220px;
  width: 220px;
}

.PortalCaregivers-module__name___NuJ1h {
  font-weight: 500;
  color: #222;
}

.PortalCaregivers-module__email___b7UYb {
  font-size: 0.95rem;
  color: #6d7278;
}

.PortalCaregivers-module__actions___OZAOH {
  display: flex;
  flex-direction: row;
  gap: 12px;
}

.PortalCaregivers-module__approveBtn___E16HR,
.PortalCaregivers-module__declineBtn___RwrIB {
  min-width: 90px;
  font-weight: 500;
  border-radius: 6px;
  box-shadow: none;
}

.PortalCaregivers-module__empty___QHIMe {
  color: #6d7278;
  text-align: left;
  padding: 24px 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/PatientDetails/fragments/PortalCaregivers/PortalCaregivers.module.scss"],"names":[],"mappings":"AACA;EACC,kBAAA;AAAD;;AAGA;EACC,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAAD;;AAGA;EACC,aAAA;EACA,sBAAA;EACA,MAAA;AAAD;;AAGA;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,gCAAA;EACG,SAAA;AAAJ;;AAGA;EACC,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;AAAD;;AAGA;EACC,gBAAA;EACA,WAAA;AAAD;;AAGA;EACC,kBAAA;EACA,cAAA;AAAD;;AAGA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAAD;;AAGA;;EAEC,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAAD;;AAGA;EACC,cAAA;EACA,gBAAA;EACA,eAAA;AAAD","sourcesContent":["\n.article {\n\tpadding: 27px 24px;\n}\n\n.heading {\n\tfont-size: 1.25rem;\n\tfont-weight: 600;\n\tmargin-bottom: 16px;\n\tcolor: #375844;\n}\n\n.inviteList {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0;\n}\n\n.inviteRow {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tpadding: 12px 0;\n\tborder-bottom: 1px solid #f1f3e7;\n    gap: 7rem;\n}\n\n.info {\n\tdisplay: flex;\n\tflex-direction: column;\n\tmin-width: 220px;\n\twidth: 220px;\n}\n\n.name {\n\tfont-weight: 500;\n\tcolor: #222;\n}\n\n.email {\n\tfont-size: 0.95rem;\n\tcolor: #6d7278;\n}\n\n.actions {\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 12px;\n}\n\n.approveBtn,\n.declineBtn {\n\tmin-width: 90px;\n\tfont-weight: 500;\n\tborder-radius: 6px;\n\tbox-shadow: none;\n}\n\n.empty {\n\tcolor: #6d7278;\n\ttext-align: left;\n\tpadding: 24px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"article": `PortalCaregivers-module__article___o_4Db`,
	"heading": `PortalCaregivers-module__heading____HUeu`,
	"inviteList": `PortalCaregivers-module__inviteList___LjPpu`,
	"inviteRow": `PortalCaregivers-module__inviteRow___ICYMp`,
	"info": `PortalCaregivers-module__info___jBY1z`,
	"name": `PortalCaregivers-module__name___NuJ1h`,
	"email": `PortalCaregivers-module__email___b7UYb`,
	"actions": `PortalCaregivers-module__actions___OZAOH`,
	"approveBtn": `PortalCaregivers-module__approveBtn___E16HR`,
	"declineBtn": `PortalCaregivers-module__declineBtn___RwrIB`,
	"empty": `PortalCaregivers-module__empty___QHIMe`
};
module.exports = ___CSS_LOADER_EXPORT___;
